import React, { useState, useEffect } from "react";
import Pagebannerintern from "./pagebanner-intern";
import returnImage from "../functions/image.js";
import Offcanvas from "./offcanvas.js";

import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase.js";

const Etudiant = () => {
    const [worksList, setWorksList] = useState([]);
    const [items, setItems] = useState([]);
    const [type, setType] = useState("");
    const [imageTab, setImageTab] = useState([]);
    const [id, setId] = useState(0);
    const [iFrame, setIFrame] = useState("");
    const [maquetteUrl, setMaquetteUrl] = useState("");
    const [maquetteImgUrl, setMaquetteImgUrl] = useState("");
    const [url, setUrl] = useState("");

    const collectionName = "etudiant";
            
    async function getStudentEvents(event) {
        let allWorks = [];
        try {
            const querySnapshot = await getDocs(collection(db, collectionName));    

            querySnapshot.forEach((doc) => {
                let work = doc.data();
                work.id = doc.id;
                allWorks.push(work);
            });
        } catch (error) {
            console.error("Erreur lors de la lecture des données:", error);
        }

        return allWorks;
    }

    useEffect(() => {
        getStudentEvents()
        .then(events => {
            setWorksList(events); // Mets à jour l'état avec le tableau
        })
        .catch(error => {
            console.error("Erreur lors de la récupération des données:", error);
        });
    }, []);

    useEffect(() => {
        if (type == "image") {
            setImageTab([{
                'alt': worksList[id].alt,
                'src': worksList[id].url
            }]);
        }

        if (type == "video") {
            setIFrame(worksList[id].iframe);
        }

        if (type == "maquette") {
            setImageTab([{
                'alt': worksList[id].alt,
                'src': worksList[id].preview
            }]);
            setMaquetteUrl(worksList[id].url);
            setMaquetteImgUrl(worksList[id].setMaquetteImgUrl);
        }

        if (type == "site") {
            setImageTab([{
                'alt': 'ff',
                'src': worksList[id].preview
            }]);
            setUrl(worksList[id].url);
        }
    }, [type, iFrame, imageTab, url, maquetteImgUrl, id]);

    useEffect(() => {
        const offcanvas = document.querySelector('.mek-offcanvas');
        if (offcanvas) {
            document.querySelector(".mek-offcanvas-close").addEventListener("click", () => {

                setTimeout(() => {
                    if (offcanvas.dataset.active == "false") {
                        setItems(prevItems => {
                            const newItems = [...prevItems];
                            newItems[offcanvas.id] = false;
                            return newItems;
                        });
                    }
                }, 50);
            });
        }
    }, [items]);

    return (
        <main>
            <Pagebannerintern breadcrumb="Etudiant" title="Réalisations d'étudiant" />
            <div className="container realisation-list pt-4 pb-4 pt-lg-5 pb-lg-5">
                <div className="row">
                    {worksList.map((item, index) => (
                        <div id={index} className="col-12 col-sm-6 col-lg-4 realisation-container">
                            <div className="realisation-background" style={{backgroundImage: `url("${process.env.PUBLIC_URL}/images/${item.miniature}.jpg")`}}>
                                <h2 className="realisation-title">{item.title}</h2>
                                <button href="" className="btn btn-primary" onClick={() => {
                                    setId(index);
                                    setType(item.type);
                                    items[index] = true;
                                    setItems(prevItems => {
                                        const newItems = [...prevItems];
                                        newItems[index] = true;
                                        return newItems;
                                    });
                                }}>En savoir plus</button>
                                {items[index] && (
                                    <Offcanvas 
                                    title={item.title} 
                                    description={item.description}
                                    active={items[index]}
                                    images={imageTab}
                                    id={index}
                                    type={item.type}
                                    iframe={iFrame}
                                    maquetteUrl={maquetteUrl}
                                    maquetteImgUrl={maquetteImgUrl}
                                    url={url} />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </main>
    )
};

export default Etudiant;